import AlertView from './alertView';

export default {
  // success: function(message, duration, details) {
  success(message, options) {
    options = options || {};

    options.message = message;
    options.type = 'positive';

    // allow user to specify if icon should be used (false) or change the icon to their desire
    options = Object.assign({
      icon: 'tick'
    }, options);

    const alert = new AlertView(options);

    return alert;
  },

  positive(...args) {
    return this.success(...args);
  },

  warning(message, options) {
    options = options || {};

    options.message = message;
    options.type = 'warning';

    // allow user to specify if icon should be used (false) or change the icon to their desire
    options = Object.assign({
      icon: 'exclamation-solid'
    }, options);

    const alert = new AlertView(options);

    return alert;
  },

  info(message, options) {
    options = options || {};

    options.message = message;
    options.type = 'info';

    // allow user to specify if icon should be used (false) or change the icon to their desire
    options = Object.assign({
      icon: 'exclamation-solid'
    }, options);

    const alert = new AlertView(options);

    return alert;
  },

  danger(message, options) {
    options = options || {};

    options.message = message;
    options.type = 'negative';

    // allow user to specify if icon should be used (false) or change the icon to their desire
    options = Object.assign({
      icon: 'warning'
    }, options);

    if (!options.canDismiss) {
      // don't allow to dismiss by default - Raf
      options.canDismiss = false;
    }

    const alert = new AlertView(options);

    return alert;
  },

  negative(...args) {
    return this.danger(...args);
  }
};

